import { useState } from 'react';
import { demoMode } from '@/lib/api';
import { getOwnerPin, setOwnerPin } from '@/lib/ownerAuth';

// Смена кода владельца. Только демо: в реальном режиме вход идёт через
// серверную D1-сессию (почта + пароль), и локального кода в браузере нет.
export function PinSettings() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  if (!demoMode) {
    return (
      <section className="mnc-step">
        <h2>
          <span className="mnc-step-num">К</span>
          Доступ владельца
        </h2>
        <p className="mnc-muted">
          Вход в кабинет — по почте и паролю владельца. Сменить пароль можно командой
          scripts/owner-set.mjs. Локального кода доступа в реальном режиме нет.
        </p>
      </section>
    );
  }

  const save = () => {
    setMsg(null);
    setErr(null);
    if (current.trim() !== getOwnerPin()) {
      setErr('Текущий код не совпадает.');
      return;
    }
    const clean = next.trim();
    if (clean.length < 4) {
      setErr('Новый код — минимум 4 символа.');
      return;
    }
    setOwnerPin(clean);
    setCurrent('');
    setNext('');
    setMsg('Код обновлён. В следующий раз входите с ним.');
  };

  const reset = () => {
    setOwnerPin('');
    setCurrent('');
    setNext('');
    setMsg(`Сброшено на код по умолчанию: ${getOwnerPin()}`);
  };

  return (
    <section className="mnc-step">
      <h2>
        <span className="mnc-step-num">К</span>
        Код доступа
      </h2>
      <p className="mnc-muted">
        Сейчас действует код <b>{getOwnerPin()}</b>. Задайте свой — он сохранится в этом браузере.
      </p>
      <label className="mnc-field">
        Текущий код
        <input
          type="password"
          inputMode="numeric"
          autoComplete="off"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
        />
      </label>
      <label className="mnc-field">
        Новый код
        <input
          type="password"
          inputMode="numeric"
          autoComplete="off"
          value={next}
          onChange={(e) => setNext(e.target.value)}
        />
      </label>
      <div className="mnc-actions" style={{ marginTop: 12 }}>
        <button className="mnc-btn" disabled={!current || !next} onClick={save}>
          Сохранить код
        </button>
        <button className="mnc-btn mnc-btn-ghost" onClick={reset}>
          Сбросить на 00000000
        </button>
      </div>
      {msg && <p className="mnc-muted">{msg}</p>}
      {err && <p className="mnc-muted">{err}</p>}
    </section>
  );
}
